<script setup lang="ts">
import { ref } from 'vue'
import TypeaheadPicker from '@/components/TypeaheadPicker.vue'
import MultiSelectDropdown from '@/components/MultiSelectDropdown.vue'

interface SampleStrategy {
  uuid: string
  title: string
}

const SAMPLE_STRATEGIES: SampleStrategy[] = [
  'Chunking',
  'Graphic Organizers',
  'Think-Pair-Share',
  'Visual Schedules',
  'Wait Time',
  'Word Banks'
].map((title, index) => ({ uuid: `strategy-${index}`, title }))

const SAMPLE_GRADES = ['K', '1', '2', '3', '4', '5'].map(grade => ({ label: grade, value: grade }))

const pickedStrategies = ref<SampleStrategy[]>([])
const selectedGrades = ref<string[]>(['K', '2'])

function searchStrategies(query: string): Promise<SampleStrategy[]> {
  const needle = query.toLowerCase()
  return new Promise(resolve =>
    setTimeout(() => resolve(SAMPLE_STRATEGIES.filter(strategy => strategy.title.toLowerCase().includes(needle))), 400)
  )
}

function addStrategy(strategy: SampleStrategy) {
  pickedStrategies.value = [...pickedStrategies.value, strategy]
}
</script>

<template>
  <div class="flex flex-col gap-6 w-6/12">
    <div class="flex flex-col gap-2">
      <label for="library-typeahead-local" class="font-bold">Typeahead, local list</label>
      <TypeaheadPicker
        id="library-typeahead-local"
        :items="SAMPLE_STRATEGIES"
        :item-label="strategy => strategy.title"
        :item-key="strategy => strategy.uuid"
        placeholder="Strategy name"
        @select="addStrategy"
      />
    </div>
    <div class="flex flex-col gap-2">
      <label for="library-typeahead-async" class="font-bold">Typeahead, async search</label>
      <TypeaheadPicker
        id="library-typeahead-async"
        :search="searchStrategies"
        :item-label="strategy => strategy.title"
        :item-key="strategy => strategy.uuid"
        placeholder="Strategy name"
        empty-text="No strategies found"
        @select="addStrategy"
      />
    </div>
    <p>Picked: {{ pickedStrategies.map(strategy => strategy.title).join(', ') || 'none' }}</p>
    <div class="flex flex-col gap-2">
      <label for="library-multiselect" class="font-bold">Multi-select dropdown</label>
      <MultiSelectDropdown id="library-multiselect" v-model="selectedGrades" :options="SAMPLE_GRADES" />
    </div>
  </div>
</template>
